import {
  AfterViewChecked,
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  NgZone,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[wilsonFitText]',
  standalone: true,
})
export class FitTextDirective
  implements AfterViewInit, OnDestroy, AfterViewChecked
{
  private readonly el = inject(ElementRef);
  private readonly ngZone = inject(NgZone);

  private resizeObserver: ResizeObserver | null = null;

  ngAfterViewChecked(): void {
    this.fit();
  }

  ngAfterViewInit(): void {
    const el = this.el.nativeElement as HTMLElement;
    el.style.whiteSpace = 'nowrap';

    // Use ResizeObserver to detect when the element actually has layout
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver(() => this.fit());
      this.resizeObserver.observe(el);
    });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private fit(): void {
    const el = this.el.nativeElement as HTMLElement;
    // Reset styles to measure from CSS baseline
    el.style.fontSize = '';
    el.style.transform = '';
    el.style.transformOrigin = '';

    if (el.clientWidth !== 0) {
      // Use transform: scale() to bypass Chrome's minimum font-size enforcement
      if (el.scrollWidth > el.clientWidth) {
        const scale = el.clientWidth / el.scrollWidth;
        el.style.transformOrigin = 'left top';
        el.style.transform = `scale(${scale})`;
      }
    }
  }
}
